import { render, staticRenderFns } from "./Justificante.vue?vue&type=template&id=20cd0126&"
import script from "./Justificante.vue?vue&type=script&lang=js&"
export * from "./Justificante.vue?vue&type=script&lang=js&"
import style0 from "./Justificante.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports